import React from "react";
import {
  ABOUTUS,
  COVERAGE_TEXT,
  OUR_SERVICES,
  PRIVACY_POLICY,
  ROUTE_LINKS,
  EMAIL,
  LOCATION,
} from "../utils/strings";

// import { SiLinkedin } from "react-icons/si";
import { FaFacebook } from "react-icons/fa";

// import { RiWhatsappFill } from "react-icons/ri";
import { AiOutlinePhone } from "react-icons/ai";
import { HiOutlineLocationMarker, HiOutlineMail } from "react-icons/hi";

// import pdf
import TermsAndConditions from "../../pdf/TermsAndConditions.pdf";
import { Container, OverlayTrigger, Popover, Row, Col } from "react-bootstrap";
import { CONTACTUS_ITEM } from "./contactus-item";
import { AnimatedButton } from "./animated-button";

// footer
export function Footer() {
  // remove
  const subHeadingFS = 15;
  const ourservices = [
    "Furniture removal",
    "Purchased deliveries",
    "Household refuse",
  ];
  const [showMore, setShowMore] = React.useState(false);

  // popover function
  const popOver = (description, caption) => {
    return (
      <Popover className="shadow-lg border-0">
        <Popover.Header className="bg-primary text-white border-0 px-4 py-3">
          <h6 className="fw-bold mb-0">{caption}</h6>
        </Popover.Header>
        <Popover.Body className="px-4 py-3">
          <p className="text-muted mb-0">{description}</p>
        </Popover.Body>
      </Popover>
    );
  };
  // popover function
  const aboutUsPopOver = (description, caption) => {
    return (
      <Popover className="shadow-lg border-0">
        <Popover.Header className="bg-primary text-white border-0 px-4 py-3">
          <h6 className="fw-bold mb-0">{caption}</h6>
        </Popover.Header>
        <Popover.Body className="px-4 py-3">
          <p className="mb-3">
            <span className="fw-bold text-primary">Xcrossing Lines </span>
            {showMore ? description : `${description.substring(0, 300)}... `}
          </p>
          <button
            className="btn btn-link text-primary p-0 text-decoration-none"
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? "Show less" : "Show more"}
          </button>
        </Popover.Body>
      </Popover>
    );
  };
  //
  const contactUsPopOver = () => {
    return (
      <Popover id="popover-basic" className="rounded-0 border-transparent">
        <Popover.Header
          as="h3"
          className="rounded-0 border-0 fw-bolder bg-secondary text-white"
        >
          Contact us
        </Popover.Header>
        <Popover.Body className="d-flex flex-column flex-wrap justify-content-start align-items-start gap-3">
          {/*Email*/}
          <CONTACTUS_ITEM icon={<HiOutlineMail size={20} />} item={[EMAIL]} />
          {/*Email*/}
          {/*Location*/}
          <CONTACTUS_ITEM
            icon={<HiOutlineLocationMarker size={20} color="red" />}
            item={[LOCATION]}
          />
          {/*Location*/}
          {/*Contact numbers*/}
          <CONTACTUS_ITEM
            icon={<AiOutlinePhone size={20} />}
            item={["(+27) 72 516 7658 or", "(+27) 81 816 6146"]}
          />
          {/*Contact numbers*/}
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <footer className="bg-dark text-white">
      {/* Main Footer */}
      <div className="py-5">
        <Container>
          <Row className="g-4">
            {/* Our Services Column */}
            <Col xs={12} sm={6} lg={3}>
              <h5 className="fw-bold mb-3">OUR SERVICES</h5>
              <ul className="list-unstyled mb-0">
                {OUR_SERVICES.map((value, k) => (
                  <li key={`${k}-item`} className="mb-2">
                    <AnimatedButton>
                      <OverlayTrigger
                        trigger="click"
                        placement="top"
                        rootClose={true}
                        overlay={popOver(value.description, value.caption)}
                      >
                        <span className="text-light text-opacity-75 small cursor-pointer">
                          {ourservices[k]}
                        </span>
                      </OverlayTrigger>
                    </AnimatedButton>
                  </li>
                ))}
              </ul>
            </Col>

            {/* About Us Column */}
            <Col xs={12} sm={6} lg={3}>
              <h5 className="fw-bold mb-3">ABOUT US</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <AnimatedButton>
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose={true}
                      overlay={aboutUsPopOver(ABOUTUS, "ABOUT US")}
                    >
                      <span className="text-light text-opacity-75 small cursor-pointer">
                        About us
                      </span>
                    </OverlayTrigger>
                  </AnimatedButton>
                </li>
                <li className="mb-2">
                  <AnimatedButton>
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose={true}
                      overlay={contactUsPopOver()}
                    >
                      <span className="text-light text-opacity-75 small cursor-pointer">
                        Contact us
                      </span>
                    </OverlayTrigger>
                  </AnimatedButton>
                </li>
                <li className="mb-2">
                  <AnimatedButton>
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose={true}
                      overlay={popOver(COVERAGE_TEXT, "AREA OF OPERATION")}
                    >
                      <span className="text-light text-opacity-75 small cursor-pointer">
                        Coverage
                      </span>
                    </OverlayTrigger>
                  </AnimatedButton>
                </li>
              </ul>
            </Col>

            {/* Quick Links Column */}
            <Col xs={12} sm={6} lg={3}>
              <h5 className="fw-bold mb-3">QUICK LINKS</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <AnimatedButton
                    onClick={() => (window.location.href = ROUTE_LINKS.faqs)}
                  >
                    <span className="text-light text-opacity-75 small cursor-pointer">
                      Frequently asked questions
                    </span>
                  </AnimatedButton>
                </li>
                <li className="mb-2">
                  <AnimatedButton
                    onClick={() =>
                      (window.location.href = ROUTE_LINKS.create_job)
                    }
                  >
                    <span className="text-light text-opacity-75 small cursor-pointer">
                      Get a free quote
                    </span>
                  </AnimatedButton>
                </li>
              </ul>
            </Col>

            {/* Social Media Column */}
            <Col xs={12} sm={6} lg={3}>
              <h5 className="fw-bold mb-3">FOLLOW US</h5>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-light rounded-circle p-2"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/profile.php?id=100083157257574",
                      "_blank"
                    )
                  }
                >
                  <FaFacebook className="text-primary" size={20} />
                </button>
                {/* Add other social media buttons here */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Copyright Section */}
      <div className="py-3 bg-dark border-top border-secondary">
        <Container>
          <div className="text-center text-light text-opacity-75 small">
            <p className="mb-2">All content &copy; {PRIVACY_POLICY}</p>
            <p className="mb-0">
              <a
                href={TermsAndConditions}
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none text-primary"
              >
                Privacy Policy
              </a>{" "}
              &bull;{" "}
              <a
                href={TermsAndConditions}
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none text-primary"
              >
                Terms & Conditions
              </a>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
}
